<template>
  <div class="pt-panel protection-info-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">{{ oneTitle }}</h2>
        <p class="pt-subtitle">防护信息 · 应急响应方案</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-section">
      <div class="pt-section-title">
        <strong>基础信息</strong>
      </div>
      <div class="pt-info-row" style="flex-direction: column; gap: 0;">
        <div style="display: flex; padding: 6px 0;">
          <strong style="width: 120px;">时间</strong>
          <span>{{ new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + '  ' + new Date().getHours() + ':' + new Date().getMinutes() }}</span>
        </div>
        <div style="display: flex; padding: 6px 0;">
          <strong style="width: 120px;">温度</strong>
          <span>32℃</span>
        </div>
        <div v-if="oneTitle=='农田'" style="display: flex; padding: 6px 0;">
          <strong style="width: 120px;">农作物种类</strong>
          <span>23</span>
        </div>
        <div v-else style="display: flex; padding: 6px 0;">
          <strong style="width: 120px;">人口数</strong>
          <span>2349</span>
        </div>
        <div style="display: flex; padding: 6px 0;">
          <strong style="width: 120px;">面积</strong>
          <span>{{ oneTitle=='农田' ? '400亩' : '300km²' }}</span>
        </div>
      </div>
    </div>

    <div class="pt-section">
      <div class="pt-section-title">
        <strong>防护方案</strong>
      </div>
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 12px;">
        <select class="pt-input" style="flex: 1; height: 30px;" v-model="value1" placeholder="请选择防护方案" @change="change">
          <option v-for="item in options" :key="item.value" :value="item.value">{{ item.label }}</option>
        </select>
        <button class="pt-btn" @click="">发布</button>
      </div>
      <div class="pt-text-box" v-if="method.first!==''">
        <p v-html="method.first"></p>
        <p v-html="method.second"></p>
        <p v-html="method.third"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "protectionInfo",
  props: {
    info: '',
    value: '',
  },
  data() {
    return {
      oneTitle: "",
      value1: "",
      options: [{
        value: '0',
        label: 'Ⅰ级应急响应'
      }, {
        value: '1',
        label: 'Ⅱ级应急响应'
      }, {
        value: '2',
        label: 'Ⅲ级应急响应'
      }, {
        value: '3',
        label: 'Ⅳ级应急响应'
      }],
      response: [{
        first: "1.镇河道防洪指挥机构按照<span style='color: #fca5a5'>《中华人民共和国防洪法》</span>的相关规定，行使权力。由主要领导主持会商，动员部署抢险工作，有关责任人上岗到位，根据方案转移危险地区群众。",
        second: "2.市防指宣布进入紧急防洪期，市防指总指挥主持会商，全面落实各级地方人民政府行政首长责任制，要求各级、<span style='color: #fca5a5'>各部门立即行动起来，投入防洪救灾工作</span>。及时将情况上报榆林市委、市政府、市防指。",
        third: "3.市防指组成前线指挥部，现场组织指挥防洪抢险和救灾工作，动员社会各界力量支援抗洪救灾工作，并做好救援资金、物资的接收和发放。"
      }, {
        first: "1.镇河道防洪指挥机构由主要领导主持会商，具体安排防洪工作，<span style='color: #fca5a5'>有关责任人上岗到位，靠前指挥</span>，迅速调集人力、物力全力组织抢险，组织实施堤防堵口，尽可能控制险情，并应明确堵口、抢护的行政、技术责任人，及时将灾情和防洪抢险工作情况报告市政府和市防指。",
        second: "2.市防指日常工作的副指挥主持会商，市防指成员参加会商，做出相应工作部署，提请市政府常务会议研究部署。",
        third: "3.<span style='color: #fca5a5'>气象部门发布中长期气象信息，向市防指提供逐日降雨、降雨时长等情况</span>，市防指其他成员单位按照职责分工和统一部署，做好相关工作。"
      }, {
        first: "1.镇河道防洪指挥机构及时向市防办报告灾情和救灾情况，<span style='color: #fca5a5'>由主要负责同志主持会商，召开防洪应急工作会议，启动防洪应急方案</span>，并将情况及时报告市防指。",
        second: "2.市防指副指挥主持会商，市防指有关成员单位派员参加，根据需要在市电视台等新闻媒体发布险情通报，<span style='color: #fca5a5'>在24小时内派督导组、技术组赶赴一线指导防洪抢险</span>，将情况及时上报市防指领导和市委、市政府，并提交防洪抢险决策建议，部署指导各镇防洪救灾。",
        third: "3.气象部门做好中、长期气象信息预报，向市防办提供降雨量、降雨时长等情况，并分析未来的天气形势和发展趋势,市防指有关成员单位按照职责分工，做好相关工作。"
      }, {
        first: "1.镇河道防洪指挥机构应按照批准的防洪方案和防汛责任制要求，<span style='color: #fca5a5'>由负责同志主持会商，组织专业和群众巡查队伍巡堤查险，严密布防，必要时动用快速机动抢险队伍或应急抢险队伍参加重要堤段、重点工程的防守或突击抢险，</span>并将水情、险情及防御工作情况报告市政府和市防指。",
        second: "2.市防办主任主持会商，市防指有关成员单位派员参加，做出相应工作安排，加强对防洪工作的指导，将情况及时报告市政府和市防指指挥、副指挥，并通报市防指成员单位。",
        third: "3.政府和市防指指挥、副指挥，并通报市防指成员单位。"
      }],
      method: {
        first: '',
        second: '',
        third: '',
      },
    }
  },
  mounted() {},
  watch: {
    info: {
      handler(val) {
        this.oneTitle = val.name
      },
      immediate: true
    },
  },
  methods: {
    closeClick() {
      this.$emit('infoClose')
    },
    change(val) {
      this.method = {}
      if (val === '0') {
        this.method = this.response[0]
      } else if (val === '1') {
        this.method = this.response[1]
      } else if (val === '2') {
        this.method = this.response[2]
      } else {
        this.method = this.response[3]
      }
    }
  }
}
</script>

<style scoped>
.protection-info-panel {
  width: 45%;
  height: 65%;
  position: absolute;
  overflow-y: auto;
  max-height: 65%;
  left: 30%;
  top: 200px;
}

.protection-info-panel select {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(56, 189, 248, 0.24);
  border-radius: 7px;
  color: #eef7ff;
  padding: 0 10px;
  font-size: 12px;
}

.protection-info-panel select option {
  background: rgba(8, 18, 32, 0.98);
  color: #eef7ff;
}
</style>
